import styled from 'styled-components';

export const FolderNameStyled = styled.div`
  padding: 4px 0px;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  align-content: center;
`;

export const WrapperStyled = styled.div`
  display: flex;
  align-items: center;
`;

export const ErrorMessageStyled = styled.div`
  font-size: 14px;
  font-weight: 400;
`;

export const ContainerStyled = styled.div`
  margin-top: -8px;
`;
